import React from "react";
import PropTypes from "prop-types";
import * as Sentry from "@sentry/browser";

import { isDev } from "shared/util/EnvironmentHelpers";
import isTest from "shared/util/isTest";

class ErrorBoundary extends React.PureComponent {
	static propTypes = {
		children: PropTypes.any,
		renderFallback: PropTypes.func.isRequired,
	};

	static defaultProps = {
		children: null,
	};

	state = {
		error: null,
	};

	componentDidCatch(error, errorInfo) {
		this.setState({ error });

		if (isDev || isTest()) {
			console.error(error);
			return;
		}

		Sentry.withScope((scope) => {
			Object.keys(errorInfo).forEach((key) => {
				scope.setExtra(key, errorInfo[key]);
			});
			Sentry.captureException(error);
		});
	}

	render() {
		if (!this.state.error) {
			return this.props.children;
		}

		return this.props.renderFallback();
	}
}

export default ErrorBoundary;



// WEBPACK FOOTER //
// ./src/shared/components/ErrorBoundary.jsx